import { h } from 'vue';
import i18n from '@/plugins/i18n';
import AnomalySideBarItem from '@/components/charts/utils/AnomalySideBarItem.vue';
import {
  AnomalyDataObjectType,
  GraphDataNamesEnum,
} from '@/components/Common/graph.types';
import { formatDate } from '@/utils/time/formatDate';
import { GraphToolTipInfoType } from '@/components/charts/utils/utils.types';
import { cloneDeep } from 'lodash';
import { getRandomUniqueId } from '@/utils/helper-function';
import { RexFilterItemsType } from '@/rex-components/rex.comp.types';

export const severityTypeMapper = [
  i18n.global.t('noBreach'),
  i18n.global.t('minorBreach'),
  i18n.global.t('majorBreach'),
  i18n.global.t('criticalBreach'),
];

export const severityKeyMapper = [
  GraphDataNamesEnum.NO_BREACH,
  GraphDataNamesEnum.MINOR_BREACH,
  GraphDataNamesEnum.MAJOR_BREACH,
  GraphDataNamesEnum.CRITICAL_BREACH,
];

export const anomalyTypeColorMapper = {
  [severityKeyMapper[1]]: '#FFDA55',
  [severityKeyMapper[2]]: '#CE5700',
  [severityKeyMapper[3]]: '#EF4444',
};

export const anomalyTagTextColor = {
  [severityKeyMapper[1]]: '#000000',
  [severityKeyMapper[2]]: '#FFFFFF',
  [severityKeyMapper[3]]: '#FFFFFF',
}

export const generateAnomalyMenuList = (anomalyList) => {
  return anomalyList?.map?.((obj, i) => ({
    label: h(AnomalySideBarItem, {
      type: severityTypeMapper[obj[GraphDataNamesEnum.SEVERITY]],
      date: formatDate(obj.x, 0, 'YYYY-MM-DD HH:mm A'),
      anomalyInfo: obj,
    }),
    sevKey: severityKeyMapper[obj[GraphDataNamesEnum.SEVERITY]],
    date: obj.x,
    key: `${i}-${getRandomUniqueId()}`,
  }));
};

export const graphTooltipInfoConfig: GraphToolTipInfoType[] = [
  {
    label: i18n.global.t('groundTruth'),
    key: GraphDataNamesEnum.GROUND_TRUTH,
  },
  {
    label: i18n.global.t('upperThreshold'),
    key: GraphDataNamesEnum.UPPER_THRESHOLD,
  },
  {
    label: i18n.global.t('lowerThreshold'),
    key: GraphDataNamesEnum.LOWER_THRESHOLD,
  },
  {
    label: i18n.global.t('forecastValue'),
    key: GraphDataNamesEnum.FORECAST_VALUE,
  },
];

export const graphTooltipKeys = cloneDeep({
  [GraphDataNamesEnum.GROUND_TRUTH]: null,
  [GraphDataNamesEnum.UPPER_THRESHOLD]: null,
  [GraphDataNamesEnum.LOWER_THRESHOLD]: null,
  [GraphDataNamesEnum.FORECAST_VALUE]: null,
  [GraphDataNamesEnum.TIMESTAMPS]: null,
});

export const anomalyInfoObject: AnomalyDataObjectType = cloneDeep({
  x: '',
  y: null,
  lt: 0,
  ut: 0,
  sev: 1,
});

export const anomalyFilterOptions: RexFilterItemsType[] = [
  {
    key: GraphDataNamesEnum.CRITICAL_BREACH,
    label: i18n.global.t('criticalBreach'),
  },
  { key: GraphDataNamesEnum.MAJOR_BREACH, label: i18n.global.t('majorBreach') },
  { key: GraphDataNamesEnum.MINOR_BREACH, label: i18n.global.t('minorBreach') },
];
